import { render, staticRenderFns } from "./AddChannelModal.vue?vue&type=template&id=81af901a&"
import script from "./AddChannelModal.vue?vue&type=script&lang=js&"
export * from "./AddChannelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports